import type { MuteToggleEventPublisher } from '@usecases/mute-toggle.usecase';
import { BusIframe } from '@main/bus-layer/bus-iframe';
import type { BusEvent } from '@main/utils/bus-event-promisifier';
import { BusEventsPromisifier } from '@main/utils/bus-event-promisifier';

export class MuteTogglePublisher implements MuteToggleEventPublisher {
  async publish(onMute: boolean): Promise<void> {
    const busIframe = await BusIframe.getIframe();

    const busEvent: BusEvent = {
      type: 'DIALER.MUTE',
      payload: {
        shouldMute: onMute,
      },
    };

    return BusEventsPromisifier.promisifyFireAndForgetEvent({
      target: busIframe,
      event: busEvent,
    });
  }
}
